import axiosInstance from "../utils/axios-instance";

export const provinceService = {
  create: async (data) => {
    try {
      let response = await axiosInstance.post("/province", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (limit, skip, text, type, country, code = []) => {
    try {
      let response = await axiosInstance.get(
        `/province?$populate=country&$limit=${limit || 15}&$skip=${skip || 0}&${
          text ? `${type}[$search]=${text}` : ""
        }${country ? `&country=${country}` : ""}${
          code.length > 0 ? code.map((x) => `&code[$in][]=${x}`).join("") : ""
        }`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  get: async (id) => {
    try {
      let response = await axiosInstance.get(`/province/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (data, id) => {
    try {
      let response = await axiosInstance.patch(`/province/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/province/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
